import { createGlobalStyle } from "styled-components"
import madeBoldEvo from "../fonts/MADE_Evolve_Sans_Bold_EVO.woff"
import madeMediumEvo from "../fonts/MADE_Evolve_Sans_Medium_EVO.woff"
import madeBold from "../fonts/MADE_Evolve_Sans_Bold.woff"
import madeRegular from "../fonts/MADE_Evolve_Sans_Regular.woff"
import madeMedium from "../fonts/MADE_Evolve_Sans_Medium.woff"
import madeLight from "../fonts/Made_Evolve_Sans_Light.woff"

const GlobalStyle = createGlobalStyle`

html,body, *::after, *::before{
    margin:0;
    padding:0;
    display:block;
    box-sizing: border-box;
    font-family: "Made Regular";
    overflow-x:hidden;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
body{
  background-color: #fffcfa;
}
p{
    font-size: 16px;
    line-height: 25px;
    margin-block-start: 0;
    margin-block-end: 0;
}

h1{
  margin-block-start: 0;
    margin-block-end: 0;
}

h2{
  margin-block-start: 0;
    margin-block-end: 0;
}

ul{
    list-style: none;
    padding-inline-start: 0;
    margin-block-start: 0;
    margin-block-end: 0;
}

button{
    border: none;
    background-color: transparent;
}

img{
    height: auto;
    max-width:100%;
}
a {
    color: #474dc4;
    display: inline-block;
}
@font-face {
  font-family: "Made Evo Bold";
  src: url(${madeBoldEvo}) format("woff");
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Made Evo Medium";
  src: url(${madeMediumEvo}) format("woff");
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Made Bold';
  src: url(${madeBold}) format('woff');
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Made Medium';
  src: url(${madeMedium}) format('woff');
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Made Regular';
  src: url(${madeRegular}) format('woff');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Made Light';
  src: url(${madeLight}) format('woff');
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}
`

export default GlobalStyle
